var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 818,
    height: 765,
    viewBox: "0 0 818 765",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4109_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.019 199.001C394.566 179.001 423.434 179.001 434.981 199.001L628.97 535.001C640.517 555.001 626.084 580.001 602.99 580.001H215.01C191.916 580.001 177.483 555.001 189.03 535.001L383.019 199.001Z",
    fill: "#25246D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4109_3600",
    x: 0.96582,
    y: 0.00146484,
    width: 816.068,
    height: 764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92,
    result: "effect1_foregroundBlur_4109_3600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.5c8d97044924b1d5899dd9e5ea3db9c0.svg";
export { ForwardRef as ReactComponent };